import { useEffect, useState } from "react";
import ValidationManager from "./validationManager";
import Validator from "./Validator";
import formHelper from "../../util/formHelper";
import ServiceTrade from "../../models/serviceTrade";
import tradeService from "../../services/tradeService";
import Trade from "../../models/trade";

const ServiceTradeEdit: React.FC<{
  item: ServiceTrade;
  onChange: any;
  isNew: boolean;
  validationManager: ValidationManager;
  validationId: string;
}> = ({
  item: serviceTrade,
  onChange,
  isNew,
  validationManager,
  validationId,
}) => {
  const validator = {
    regularTimeRate: `${validationId}_regularTimeRate`,
    overtimeRate: `${validationId}_overtimeRate`,
    holidayRate: `${validationId}_holidayRate`,
    trade: `${validationId}_trade`,
  };

  const [trades, setTrades] = useState<Trade[]>([]);

  useEffect(() => {
    const init = async () => {
      try {
        const { data: trades } = await tradeService.getTrades();
        setTrades(trades);
      } catch (error) {
        // TODO: show error with toastr
      }
    };

    if (!isNew) {
      validationManager.setIsValid(validator.regularTimeRate, true);
      validationManager.setIsValid(validator.overtimeRate, true);
      validationManager.setIsValid(validator.holidayRate, true);
      validationManager.setIsValid(validator.trade, true);
    }

    init();
  }, [
    validationManager,
    isNew,
    validator.regularTimeRate,
    validator.overtimeRate,
    validator.holidayRate,
    validator.trade,
  ]);

  const onServiceTradeChange = (event: any) => {
    const { id, name, value } = formHelper.getDataFromEvent(event.target);
    const newServiceTrade = { ...serviceTrade, [name]: value };
    onChange(newServiceTrade);

    if (id === validator.regularTimeRate) {
      const isValid = value.length !== 0;
      validationManager.setIsValid(validator.regularTimeRate, isValid);
    }

    if (id === validator.overtimeRate) {
      const isValid = value.length !== 0;
      validationManager.setIsValid(validator.overtimeRate, isValid);
    }

    if (id === validator.holidayRate) {
      const isValid = value.length !== 0;
      validationManager.setIsValid(validator.holidayRate, isValid);
    }

    if (id === validator.trade) {
      const isValid = value.length !== 0;
      validationManager.setIsValid(validator.trade, isValid);
    }
  };

  const onTradeNameChanged = (event: any) => {
    const newValue = event.target.value;
    const idTrade = Number(newValue);
    const trade = trades.find((t) => t.idTrade === idTrade);
    if (trade) {
      const newServiceTrade = {
        ...serviceTrade,
        idTrade: trade.idTrade,
        trade: trade,
      };
      onChange(newServiceTrade);

      validationManager.setIsValid(validator.trade, true);
    }
  };
  return (
    <>
      <div className="col-3  mb-3">
        <Validator
          name={validator.trade}
          errorMessage="Please enter a trade"
          validationManager={validationManager}
        >
          <div>
            <label htmlFor="trade" className="form-label">
              Trade
            </label>
            <select
              className="form-select"
              aria-label="select"
              id="trade"
              value={
                !serviceTrade.trade || serviceTrade.trade.idTrade === 0
                  ? ""
                  : serviceTrade.trade.idTrade
              }
              onChange={onTradeNameChanged}
            >
              <option value="" disabled>
                Please select
              </option>
              {trades.map((trade, index) => (
                <option key={trade.idTrade} value={trade.idTrade}>
                  {trade?.tradeName}
                </option>
              ))}
            </select>
          </div>
        </Validator>
      </div>
      <div className="col-md-3 mb-3">
        <Validator
          name={validator.regularTimeRate}
          errorMessage="Please enter a regular time rate."
          validationManager={validationManager}
        >
          <div>
            <label htmlFor="regularTimeRate" className="form-label">
              Regular Time Rate
            </label>
            <input
              type="text"
              className="form-control"
              id={`${validationId}_regularTimeRate`}
              name={formHelper.nameOf<ServiceTrade>((t) => t.regularTimeRate)}
              value={serviceTrade.regularTimeRate}
              onChange={onServiceTradeChange}
            />
          </div>
        </Validator>
      </div>
      <div className="col-md-3 mb-3">
        <Validator
          name={validator.overtimeRate}
          errorMessage="Please enter an overtime rate."
          validationManager={validationManager}
        >
          <div>
            <label htmlFor="overtimeRate" className="form-label">
              Overtime Rate
            </label>
            <input
              type="text"
              className="form-control"
              id={`${validationId}_overtimeRate`}
              name={formHelper.nameOf<ServiceTrade>((t) => t.overtimeRate)}
              value={serviceTrade.overtimeRate}
              onChange={onServiceTradeChange}
            />
          </div>
        </Validator>
      </div>

      <div className="col-md-3 mb-3">
        <Validator
          name={validator.holidayRate}
          errorMessage="Please enter a holiday rate."
          validationManager={validationManager}
        >
          <div>
            <label htmlFor="holidayRate" className="form-label">
              Holiday Rate
            </label>
            <input
              type="text"
              className="form-control"
              id={`${validationId}_holidayRate`}
              name={formHelper.nameOf<ServiceTrade>((t) => t.holidayRate)}
              value={serviceTrade.holidayRate}
              onChange={onServiceTradeChange}
            />
          </div>
        </Validator>
      </div>
    </>
  );
};

export default ServiceTradeEdit;
